
import TestInstructionsStepFourComponent from '@/components/Shared/RegisterTest/TestInstructionsStepFour/TestInstructionsStepFourComponent';
export default TestInstructionsStepFourComponent;
